const uniqBy = require('lodash/uniqBy');

export default() => ({
	data: [],
	regions: [],
	solutions: [],
	selected_region: '',
	selected_solution: '',
	sortByLabel(a, b) {
		const a_label = a.label.toUpperCase();
		const b_label = b.label.toUpperCase();
		if ( a_label < b_label ) { return -1; }
		if ( a_label > b_label ) { return 1; }
		return 0;
	},
	init() {
		const raw_data = JSON.parse( this.$refs.data.textContent );
		this.solutions = uniqBy(
			raw_data.map( _ => ({
				value: _.solution.value,
				label: _.solution.label,
				regions: [],
			}) ),
			_ => _.value
		).sort(this.sortByLabel);
		this.regions = uniqBy(
			raw_data.map( _ => _.region ),
			_ => _.value
		).sort(this.sortByLabel);

		this.data = raw_data.map( _ => {
			let solution = this.solutions.find( s => s.value === _.solution.value );
			if ( !solution.regions.includes(_.region.value) ) {
				solution.regions.push(_.region.value);
			}
			return {
				content: _.content,
				region: _.region.value,
				solution: _.solution.value,
			};
		} );
	},
	get solution_prompt() {
		return this.selected_region.length > 0 ? 'Select Solution' : '';
	},
	get available_regions() {
		return this.regions;
	},
	get available_solutions() {
		return this.solutions.filter(_ => _.regions.includes(this.selected_region));
	},
	get content() {
		if (
			this.selected_region.length === 0
			|| this.selected_solution.length === 0
		) {
			return '';
		}

		const entry = this.data.find( _ => _.region === this.selected_region && _.solution === this.selected_solution);
		return entry === undefined ? '' : entry.content;
	}
});
